// Convert a YouTube/Vimeo/TikTok/Instagram URL into an embeddable iframe src.
// Returns null when the url isn't a recognized embeddable provider
// (callers fall back to a plain link or an <video> tag).
export function toEmbedSrc(url: string): string | null {
  try {
    const u = new URL(url);
    const host = u.hostname.replace('www.', '');
    if (host === 'youtu.be') return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (host === 'youtube.com' || host === 'm.youtube.com') {
      const id = u.searchParams.get('v');
      if (id) return `https://www.youtube.com/embed/${id}`;
      if (u.pathname.startsWith('/embed/')) return url;
      const short = u.pathname.match(/^\/shorts\/([\w-]{6,})/);
      if (short) return `https://www.youtube.com/embed/${short[1]}`;
    }
    if (host === 'vimeo.com') {
      const id = u.pathname.split('/').filter(Boolean)[0];
      if (id) return `https://player.vimeo.com/video/${id}`;
    }
    if (host === 'player.vimeo.com') return url;
    // TikTok: full video links only — short vt./vm. links need a server-side
    // redirect to reveal the id (the portal resolves them; here they are skipped).
    if (host === 'tiktok.com' || host === 'm.tiktok.com') {
      const id = u.pathname.split('/').find(p => /^\d{15,22}$/.test(p));
      if (id) return `https://www.tiktok.com/player/v1/${id}?rel=0&description=0&music_info=0`;
    }
    if (host === 'instagram.com') {
      const parts = u.pathname.split('/').filter(Boolean);
      const i = parts.findIndex(p => p === 'reel' || p === 'reels' || p === 'p' || p === 'tv');
      if (i >= 0 && parts[i + 1]) return `https://www.instagram.com/p/${parts[i + 1]}/embed/`;
    }
  } catch {
    return null;
  }
  return null;
}
